import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { forkJoin } from 'rxjs/observable/forkJoin';
import {SettingFiles} from '../../../dominio/settingFiles';

@Component({
    selector: 'app-files',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss']
})
export class FilesComponent {
    @Input('settings')settings: SettingFiles;
    @Output('saveFiles')output = new EventEmitter();
    @ViewChild('file') file;
    public files: Set<File> = new Set();
    progress;
    canBeClosed = true;
    showCancelButton = true;
    uploading = false;
    uploadSuccessful = false;

    constructor() {}


    addFiles() {
        if (!this.settings.multiple) {
            this.reset();
        }
        this.file.nativeElement.click();
    }

    onFilesAdded() {
        const files: { [key: string]: File } = this.file.nativeElement.files;
        for (let key in files) {
            if (!isNaN(parseInt(key))) {
                this.files.add(files[key]);
            }
        }
    }

    delete(name) {
        // this.files.delete(name);
       // console.log(this.file.nativeElement.files);
        this.files = new Set<File>();
}

    reset() {
       //this.file = new Set();
    }

    save() {
        // set the component state to 'uploading'
        this.uploading = true;

        // start the upload and save the progress map
        //this.progress = this.filesServices.upload(this.files);
        this.output.emit(this.files);

        // convert the progress map into an array
        let allProgressObservables = [];
        for (let key in this.progress) {
            allProgressObservables.push(this.progress[key].progress);
        }

        // The dialog should not be closed while uploading
        this.canBeClosed = false;

        // Hide the cancel-button
        this.showCancelButton = false;

        // When all progress-observables are completed...
        forkJoin(allProgressObservables).subscribe(end => {
            // ... the dialog can be closed again...
            this.canBeClosed = true;

            // ... the upload was successful...
            this.uploadSuccessful = true;

            // ... and the component is no longer uploading
            this.uploading = false;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/files/dialog/dialog.component.ts